import { Component, NgModule, OnInit } from '@angular/core';
import * as data from 'src/assets/data.json';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
  public headers: string[] = [];
  public rows: Array<{ [key: string]: string; }> = [];
  constructor() { }
  ngOnInit(): void {
    let infoHeaders = Object.keys(data.data[0].info)
    let scoresHeaders = Object.keys(data.data[0].scores)
    this.headers = infoHeaders.concat(scoresHeaders)
    let rows = []
    for(let i = 0; i<data.data.length; i++){
      let dataWithFormat: { [key: string]: any; } = data.data[i]
      let row: { [key: string]: string; } = {}
      for(let j=0; j<infoHeaders.length; j++){       
        let record = infoHeaders[j]
        row[record] = dataWithFormat.info[record]
      }
      for(let j=0; j<scoresHeaders.length; j++){
        let dataWithFormat: { [key: string]: any; } = data.data[i]
        let record = scoresHeaders[j]
        row[record] = dataWithFormat.scores[record]
      }
      rows.push(row)
    }
    this.rows = rows;
  }

}
